import React from 'react';

const Diff = ({ value }: Props) => {
  if(value === null) {
    return null;
  }
  return (
    <div className={`d-flex align-items-center me-2 ${value > 0 ? 'text-success' : 'text-danger'}`}>
      <i className={`ti ti-chevron-${value > 0 ? 'up' : 'down'}`} />
      <div>{Math.abs(value)}%</div>
    </div>
  );
}

interface Props {
  value: number | null
}

export { Diff };